
















































































































































































































































































































































































import BaseEdit from './BaseEdit';
import { Component, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
import printJS from 'print-js';
import Constants from '@/constants';
import { stat } from 'fs';
import ApproveModal from '@/pages/patients/ApproveModal.vue';
import FileUploader from '@/components/FileUploader.vue';

@Component({
  components: {
    ApproveModal,
    'file-uploader': FileUploader
  },
})
export default class Edit extends BaseEdit {
  form = {
    id: '',
    patientId: '',
    additionComment: '',
    comment: '',
    statuses: [],
    genders: [],
    bloodTypes: [],
    cmvStatuses: [],
    rhs: [],
    hlas: [],

    timeout: '',
    status: '',

    rejectionReasons: [],
    operators: [],
    operatorsData: [],
    operatorName: '',
    operatorEmail: '',
    operatorPhone: '',
    operatorAdphone: '',

    getCellsFactDate: '',
    getCellsFactMethod: '',
    cellularity: '',
    isFrozen: '',
  } as any;

  init = false;
  isShowApproveModal = false;
  files: any[] = [];

  get isReadyPartVisible() {
    return this.loadedStatusIn(['Готов', 'Сбор клеток', 'Сбор выполнен']);
  }

  get isReadyPartDisabled() {
    return this.loadedStatusIn(['Сбор клеток', 'Сбор выполнен']);
  }

  get showBackToPatient() {
    return !this.$auth.user().isLr && this.form.patientId;
  }

  get isActivation() {
    return this.currentStatus || this.currentStatus.value == this.$t('Ожидание ТЦ');
  }

  async onStatusChanged(value: any) {
    if(this.form.status == value) return;
    //@ts-ignore
    if(this.form.status > value && !(this.form.status == 16 && value == 9) || [3,4,5,6,16].includes(value)) {
      //@ts-ignore
      let newStatusName = this.form.statuses.filter(s => s.key == value)[0].value;
          let msgText = '<span style="color:black; font-size: 18px">Это действие отменит текущий статус. <br/>Будет выставлен предыдущий статус <b>"' + newStatusName + '"</b>. <br/>Выполнить операцию?</span>';
      if([3,4,5,6].includes(value)) {
        msgText = '<span style="color:black; font-size: 18px">Вы действительно хотите сделать <span style="color:red">ОТКАЗ</span>? <br/>В результате будет выставлен статус <b>"' + newStatusName + '"</b>. <br/> Выполнить операцию?</span>';
      }
      const msgHtml = document.createElement("div");
      msgHtml.innerHTML = msgText;
      //@ts-ignore
      this.$swal({
        icon: 'warning',
        title: this.$t('Предупреждение'),
        content: msgHtml,
        buttons: [this.$t('Нет'), this.$t('Да')],
      }).then(async (doChange: any) => {
        if (doChange) {
          const status = this.getStatusByKey(value);
          const oldStatusKey = this.form.status;
          const oldStatus = this.getStatusByKey(this.form.status);
          if (oldStatus.value == this.$t('Ожидание ТЦ') && status.value == this.$t('Запрос на заготовку')) {
            this.isShowApproveModal = !this.isShowApproveModal;
          } else {
            this.form.status = status.key;
            await this.submitWithFile(
              '/donorsatwork',
              false,
              this.showStatusChangeError
            );
            if (this.isStatusChangeError) {
              this.form.status = oldStatusKey;
            }
          }
        }
      });
    } else {
          const status = this.getStatusByKey(value);
          const oldStatusKey = this.form.status;
          const oldStatus = this.getStatusByKey(this.form.status);
          if (oldStatus.value == this.$t('Ожидание ТЦ') && status.value == this.$t('Запрос на заготовку')) {
            this.isShowApproveModal = !this.isShowApproveModal;
          } else {
            this.form.status = status.key;
            await this.submitWithFile(
              '/donorsatwork',
              false,
              this.showStatusChangeError
            );
            if (this.isStatusChangeError) {
              this.form.status = oldStatusKey;
            }
          }
    }
  }

  approveDonor() {
    this.approve().then(() => {
      window.location.reload();
    });    
  }

  async approve() {
    let formData = new FormData();
    this.form.status = this.getStatusByName('Запрос на заготовку').key;
    formData.append('json', JSON.stringify(this.form));

    await this.submit(
      '/donorsatwork',
      false,
      '',
      formData,
      this.showStatusChangeError
    );
    this.isShowApproveModal = false;
  }

  printStemCellRequestForm() {
    printJS({
      printable:
        Constants.baseUrl +
        '/donors/StemCellRequestForm?donorid=' +
        this.form.id,
      modalMessage: this.$t('Загрузка документа...') + '',
      type: 'pdf',
    });
  }

  printDonorAndRecipientInfoForm() {
    printJS({
      printable:
        Constants.baseUrl +
        '/donors/DonorAndRecipientInfoForm?donorid=' +
        this.form.id,
      modalMessage: this.$t('Загрузка документа...') + '',
      type: 'pdf',
    });
  }

  printRequestedCellNumberForm() {
    printJS({
      printable:
        Constants.baseUrl +
        '/donors/RequestedCellNumberForm?donorid=' +
        this.form.id,
      modalMessage: this.$t('Загрузка документа...') + '',
      type: 'pdf',
    });
  }
}
